<div class="container" *ngIf="automation">
  <button
    class="container__back-button"
    mat-icon-button
    matTooltip="Go to List"
    [routerLink]="automation.id ? ['../../'] : ['../']"
  >
    <mat-icon svgIcon="chevron_left"></mat-icon>
  </button>
  <button mat-flat-button color="primary" [disabled]="!ui.isValid" (click)="save()" class="container__save-button">
    Save
  </button>
  <div class="container__lanes">
    <div class="container__lanes__basic-info-lane">
      <div
        class="container__lanes__basic-info-lane__default animate__animated animate__bounceIn"
        [class.selected]="ui.activePropertiesPanel === PropertiesPanel.Basic"
      >
        <app-automation-builder-basic-setup-card [automation]="automation" (open)="onOpenBasicSetup()">
        </app-automation-builder-basic-setup-card>
      </div>
    </div>
    <ng-container *ngIf="automation.name && automation.target_model">
      <div class="container__lanes__strands-lane">
        <div class="container__lanes__strands-lane__strand">
          <p></p>
          <em class="thick-arrow-down"></em>
        </div>
      </div>
      <div class="container__lanes__triggers-lane">
        <div
          class="container__lanes__triggers-lane__list animate__animated animate__bounceIn"
          [class.selected]="ui.activePropertiesPanel === PropertiesPanel.Triggers"
        >
          <app-automation-builder-triggers-setup-card
            [automation]="automation"
            [formData]="formData"
            (open)="onOpenTriggersSetup()"
          ></app-automation-builder-triggers-setup-card>
        </div>
      </div>
    </ng-container>
    <div *ngIf="automation.actions?.length > 1" class="container__lanes__strands-lane">
      <div class="container__lanes__strands-lane__strand">
        <p></p>
      </div>
    </div>
    <div class="container__lanes__actions-lane">
      <div
        *ngFor="let action of automation.actions; let i = index; let isFirst = first; let isLast = last"
        class="container__lanes__actions-lane__action-box"
        [class.left]="automation.actions?.length > 1 ? isFirst : false"
        [class.center]="!isFirst && !isLast"
        [class.right]="automation.actions?.length > 1 ? isLast : false"
      >
        <div class="container__lanes__actions-lane__action-box__strand">
          <p></p>
          <em class="thick-arrow-down"></em>
        </div>
        <div
          class="container__lanes__actions-lane__action-box__item animate__animated animate__bounceIn"
          [class.selected]="ui.activePropertiesPanel === PropertiesPanel.Action && ui.activePropertiesId === action.id"
        >
          <app-automation-builder-action-setup-card
            [automation]="automation"
            [index]="i"
            [formData]="formData"
            (open)="onOpenActionSetup($event)"
            (addAction)="onAddAction()"
          ></app-automation-builder-action-setup-card>
        </div>
      </div>
    </div>
  </div>
  <div [@slideInOut]="ui.activePropertiesPanel ? 'in' : 'out'" class="container__setup">
    <ng-container [ngSwitch]="ui.activePropertiesPanel">
      <app-automation-builder-basic-setup-form
        *ngSwitchCase="PropertiesPanel.Basic"
        [automation]="automation"
        (ok)="onBasicSetupChanged($event)"
        (cancel)="cancel()"
      ></app-automation-builder-basic-setup-form>
      <app-automation-builder-triggers-setup-form
        *ngSwitchCase="PropertiesPanel.Triggers"
        [automation]="automation"
        [id]="ui.activePropertiesId"
        [formData]="formData"
        (ok)="onTriggersSetupChanged($event)"
        (cancel)="cancel()"
      ></app-automation-builder-triggers-setup-form>
      <app-automation-builder-action-setup-form
        *ngSwitchCase="PropertiesPanel.Action"
        [automation]="automation"
        [id]="ui.activePropertiesId"
        [formData]="formData"
        (ok)="onActionSetupChanged($event)"
        (cancel)="cancel()"
      ></app-automation-builder-action-setup-form>
    </ng-container>
  </div>
</div>
